export default "__VITE_ASSET__SB2qCb7e__"